import React from 'react';
import { IconCheckCircle } from '../Icons';

export default function StepConferma({ result, onReset }) {
  if (!result) return null;

  /* Da quando l'import gira di fondo (13/10/2026) il riepilogo arriva dal LAVORO, che conta
     in italiano: `inseriti`, non `inserted`. I vecchi nomi restano come ripiego, perche' lo
     stesso riquadro serve anche i riassunti salvati prima. */
  const n = (...nomi) => {
    for (const k of nomi) if (typeof result[k] === 'number') return result[k];
    return 0;
  };
  const inserted = n('inseriti', 'inserted');
  const updated = n('aggiornati', 'updated');
  const existing = n('gia_presenti', 'existing');
  const duplicati = n('duplicati');
  const daQualificare = n('in_attesa');
  const { skip_duplicates = true, province_distribution = {} } = result;

  const provEntries = Object.entries(province_distribution).sort((a, b) => b[1] - a[1]);
  const totalProv = provEntries.reduce((s, [, v]) => s + v, 0);

  return (
    <div>
      <div className="card" style={{ textAlign: 'center', padding: '32px 20px' }}>
        <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'center' }}><IconCheckCircle size={64} color="#22c55e" /></div>
        <h2 style={{ fontSize: 22, textTransform: 'none', letterSpacing: 0, color: '#059669' }}>
          Importazione Completata
        </h2>
        <p style={{ color: '#64748b', marginBottom: 0 }}>
          Il file è stato elaborato con successo.
        </p>
      </div>

      <div className="card">
        <h2>Risultati</h2>
        <div className="kpi-grid">
          <div className="kpi" style={{ borderLeftColor: '#10b981' }}>
            <div className="label">Inseriti</div>
            <div className="value" style={{ color: '#059669' }}>{inserted}</div>
          </div>
          {!skip_duplicates && (
            <div className="kpi" style={{ borderLeftColor: '#3b82f6' }}>
              <div className="label">Aggiornati</div>
              <div className="value" style={{ color: '#2563eb' }}>{updated}</div>
            </div>
          )}
          <div className="kpi" style={{ borderLeftColor: '#ef4444' }}>
            <div className="label">{skip_duplicates ? 'Duplicati saltati' : 'Già presenti'}</div>
            <div className="value" style={{ color: '#dc2626' }}>{skip_duplicates ? duplicati : existing}</div>
          </div>
          {daQualificare > 0 && (
            <div className="kpi" style={{ borderLeftColor: '#06b6d4' }}>
              <div className="label">Da qualificare</div>
              <div className="value" style={{ color: '#0891b2' }}>{daQualificare}</div>
            </div>
          )}
        </div>
        {daQualificare > 0 && (
          <p style={{ marginTop: 12, fontSize: 13, color: '#64748b' }}>
            {daQualificare} righe non avevano un numero di rete fissa: sono in <strong>Da qualificare</strong>,
            come lista «da import», pronte perché l’agente cerchi l’azienda e il suo fisso.
          </p>
        )}
        {skip_duplicates && (duplicati > 0) && (
          <p style={{ marginTop: 12, fontSize: 13, color: '#64748b' }}>
            {duplicati} numeri erano già presenti (confronto sul numero pulito) e non sono stati reimportati.
          </p>
        )}
      </div>

      {provEntries.length > 0 && (
        <div className="card">
          <h2>Distribuzione Province</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {provEntries.map(([prov, count]) => (
              <div key={prov} style={{
                padding: '4px 12px',
                background: '#f0fdf4',
                borderRadius: 20,
                fontSize: 12,
                fontWeight: 600,
                color: '#166534',
                border: '1px solid #bbf7d0',
              }}>
                {prov}: {count}
                {totalProv > 0 && (
                  <span style={{ fontWeight: 400, color: '#64748b', marginLeft: 4 }}>
                    ({Math.round(count / totalProv * 100)}%)
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="card" style={{ display: 'flex', justifyContent: 'center' }}>
        <button className="btn btn-primary" style={{ padding: '10px 24px', fontSize: 14 }} onClick={onReset}>
          Importa un altro file
        </button>
      </div>
    </div>
  );
}
